
import React, {useState, useEffect } from "react";
import {getPlanetTransit} from "../action/api-services";
import moment from "moment";
import {useDispatch, useSelector} from "react-redux";
import PageLoader from "../component/loader";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";


const PlanetTransitPage = () => {
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [planetTransitData, setPlanetTransitData] = useState([]);
    const userToken = useSelector((state) => state.userToken.value);
    const navigate = useNavigate();

    
    const dailymoonTran = 12;
    let moonDeg = 0;
    let moonDegDate = '';


    const isWeekdayAllowed = (date) => {
        const day = date.getDay();    
        return day !== 0 && day !== 6; // Exclude weekends and holidays
      };
    
    useEffect(() =>{
        if(userToken){
            getPlanetTransit(userToken).then(function (response) {
                setPlanetTransitData(response.data.data);
                setLoader(true);
            }).catch(function (err) {console.log("Error", err) });
        }else{
            navigate(`/`);
        }
    },[userToken])
   

    const moonTihi = (obj) =>{
        if(obj.moonTithi !=='' && obj.sunMoonDeg === "0.00"){
            moonDeg = 0;
        } else if(obj.date === moonDegDate){
            moonDeg = moonDeg;
        }else{
            moonDeg =  Math.round(moonDeg + dailymoonTran);
            moonDegDate = obj.date;
        }
        
        return moonDeg;
    }
    
    const todayDate = moment().format('YYYY_MM_DD');
    const prevDate =  moment().subtract(1, 'day').format('YYYY_MM_DD');
    
    setTimeout (()=>{
        document.querySelector(`#date_${prevDate}`)?.scrollIntoView({ behavior: "smooth", block: "start"});
        if(document.querySelector(`#date_${todayDate}`)){
            document.querySelector(`#date_${todayDate}`).style.backgroundColor  = "#d0ecd8";
        }
        
    }, 1200)


   


    
return (
    <React.Fragment>
        <div className="pageContainer">
        {
            (loader === false? <PageLoader />: 
            <div className="pagewrap fullheight">
                <table className="planetTransit">
                    <thead>
                        <tr key={`item_0`}>
                            <th style={{width:'80px'}}><a href="https://www.drikpanchang.com/planet/position/planetary-positions-sidereal.html" target="_blank">Date</a></th>
                            <th><a href="https://www.drikpanchang.com/planet/transit/nakshatra/chandra-nakshatra-transit-date-time.html" target="_blank">Moon Nakshatra</a></th>
                            <th><a href="https://www.drikpanchang.com/planet/transit/chandra-transit-date-time.html" target="_blank">Moon Rashi</a></th>
                            <th><a href="https://www.timeanddate.com/moon/phases/india/mumbai" target="_blank">Moon Tithi</a></th>
                            <th><a href="https://www.drikpanchang.com/planet/transit/nakshatra-pada/surya-nakshatra-pada-transit-date-time.html" target="_blank">Sun Nakshatra</a></th>
                            <th><a href="https://www.drikpanchang.com/planet/transit/surya-transit-date-time.html" target="_blank">Sun Rashi</a></th>
                            <th><a href="https://www.drikpanchang.com/planet/transit/nakshatra-pada/budha-nakshatra-pada-transit-date-time.html" target="_blank">Mercury Nakshatra</a></th>
                            <th><a href="https://www.drikpanchang.com/planet/transit/budha-transit-date-time.html" target="_blank">Mercury Rashi</a></th>
                            <th><a href="https://www.drikpanchang.com/planet/transit/nakshatra-pada/guru-nakshatra-pada-transit-date-time.html" target="_blank">Jupiter Nakshatra</a></th>
                            <th><a href="https://www.drikpanchang.com/planet/transit/guru-transit-date-time.html" target="_blank">Jupiter Rashi</a></th>
                        </tr>
                    </thead>
                    <tbody>
                    
                    {
                    planetTransitData?.map((obj, index)=>{
                        // console.log(obj)
                        let moonDeg = moonTihi(obj);
                        return(
                            <tr key={`item_${index+1}`} id={`date_${moment(obj.date).format('YYYY_MM_DD')}`}>
                                <td>
                                    {moment(obj.date).format('DD/MM/YYYY')}
                                    
                                    <div className="time">{moment(obj.date).format('dddd')}</div>
                                </td>

                                <td style={{'width':'165px'}}>
                                    {obj.moonNakshatra}
                                    <div className="time">{moment(obj.moonNakshatraTranTime).format('hh:mm A')}</div>
                                </td>
                                
                                <td style={{'width':'165px'}}>
                                    {obj.moonRashi}
                                    <div className="time">{obj.moonRashi !==''? moment(obj.moonRashiTranTime).format('hh:mm A'):''}</div>
                                </td>

                                <td style={{'width':'165px'}}  className={`tithi ${ 

                                    (moonDeg === 12 || moonDeg === 84 || moonDeg === 180 || moonDeg === 276)? "mphase90" : (moonDeg === 48 || moonDeg === 132 || moonDeg === 228 || moonDeg === 312)? "mphase45":"" 
                                    // (moonDeg === 60 || moonDeg === 84) 
                                    // && moment(obj.date).format('dddd') === "Tuesday"? "red":""

                                    // obj.moonRashi === "Vrishchika"? "red":""

                                }`}>
                                    {obj.moonTithi} <div className="time">{moonDeg}</div>
                                </td>
                                

                                <td style={{'width':'165px'}}>
                                    {obj.sunNakshatra}{obj.sunNakshatraPada !== '' ? ` [${obj.sunNakshatraPada}]` : ''}
                                    <div className="time">{obj.sunNakshatra !==''? moment(obj.sunNakshatraTime).format('hh:mm A'):''}</div>
                                </td>
                                
                                <td style={{'width':'165px'}}>
                                    {obj.sunRashi}
                                    <div className="time">{obj.sunRashi !==''? moment(obj.sunRashiTranTime).format('hh:mm A'):''}</div>
                                </td>

                                <td style={{'width':'165px'}}>
                                    {obj.budhaNakshatra}{obj.budhaNakshatraPada !== '' ? ` [${obj.budhaNakshatraPada}]` : ''}
                                    <div className="time">{obj.budhaNakshatra !==''? moment(obj.budhaNakshatraTranTime).format('hh:mm A'):''}</div>
                                </td>
                                
                                <td style={{'width':'165px'}}>
                                    {obj.budhaRashi}
                                    <div className="time">{obj.budhaRashi !==''? moment(obj.budhaRashiTranTime).format('hh:mm A'):''}</div>
                                </td>

                                <td style={{'width':'165px'}}>
                                    {obj.guruNakshatra}{obj.guruNakshatraPada !== '' ? ` [${obj.guruNakshatraPada}]` : ''}
                                    <div className="time">{obj.guruNakshatra !==''? moment(obj.guruNakshatraTranTime).format('hh:mm A'):''}</div>
                                </td>
                                
                                <td style={{'width':'165px'}}>
                                    {obj.guruRashi}
                                    <div className="time">{obj.guruRashi !==''? moment(obj.guruRashiTranTime).format('hh:mm A'):''}</div>
                                </td>
                                
                                
                            </tr>

                            
                        )  
                        
                        
                    })
                
                    }
                    </tbody>
                </table>
            </div>
            )
        }
        </div>
    </React.Fragment>
)

}
export default PlanetTransitPage;